export const PAYER_LIST_LOADING_STATES = {
    GET_PAYER_LIST_LOADING: "GET_PAYER_LIST_LOADING",
    GET_PAYER_LIST_READY: "GET_PAYER_LIST_READY",
    GET_HEADER_FOR_PAYERS_REPORT_LOADING : "GET_HEADER_FOR_PAYERS_REPORT_LOADING",
    GET_HEADER_FOR_PAYERS_REPORT_READY :"GET_HEADER_FOR_PAYERS_REPORT_READY",
    DOWNLOAD_PAYER_REPORT_LOADING : "DOWNLOAD_PAYER_REPORT_LOADING",
    DOWNLOAD_PAYER_REPORT_READY: "DOWNLOAD_PAYER_REPORT_READY",
    DEACTIVATE_PAYER_LOADING: "DEACTIVATE_PAYER_LOADING",
    DEACTIVATE_PAYER_READY: "DEACTIVATE_PAYER_LOADING",
    ACTIVATE_PAYER_LOADING: "ACTIVATE_PAYER_LOADING",
    ACTIVATE_PAYER_READY: "ACTIVATE_PAYER_READY",
    DELETE_PAYER_LOADING: "DELETE_PAYER_LOADING",
    DELETE_PAYER_READY: "DELETE_PAYER_READY"
}

export const PAYER_LIST_MESSAGE_MAP = {
    [PAYER_LIST_LOADING_STATES.GET_PAYER_LIST_LOADING]: "",
    [PAYER_LIST_LOADING_STATES.GET_HEADER_FOR_PAYERS_REPORT_LOADING]: "",
    [PAYER_LIST_LOADING_STATES.DEACTIVATE_PAYER_LOADING]: "Deactivating Payers",
    [PAYER_LIST_LOADING_STATES.ACTIVATE_PAYER_LOADING]: "Activating Payers",
    [PAYER_LIST_LOADING_STATES.DELETE_PAYER_LOADING]: "Deleting Payers"
}